export const DOMAIN = 'SleepDiaryReinforcement';
